import { EComparisonAlbumsActionTypes } from '../../actions/comparisonAlbums/types';
import { EComparisonAlbumsStatus, type IComparisonAlbumsState } from '../../types/comparisonAlbums';
import { type TReduxActions } from '../../types/redux';

export const comparisonAlbumsInitialState: IComparisonAlbumsState = {
  status: EComparisonAlbumsStatus.Initial,
  albums: [],
};

export const comparisonAlbumsReducer = (
  state: IComparisonAlbumsState = comparisonAlbumsInitialState,
  action: TReduxActions,
): IComparisonAlbumsState => {
  switch (action.type) {
    case EComparisonAlbumsActionTypes.Loading:
      return {
        ...state,
        status: EComparisonAlbumsStatus.Loading,
      };

    case EComparisonAlbumsActionTypes.Succeed:
      return {
        status: EComparisonAlbumsStatus.Succeed,
        albums: action.payload,
      };

    case EComparisonAlbumsActionTypes.Failed:
      return {
        status: EComparisonAlbumsStatus.Failed,
        albums: [],
      };

    default:
      return state;
  }
};
